import { Link } from "react-router-dom";

const quickLinks = [
  { label: "剧情介绍", to: "/category/plot" },
  { label: "演员信息", to: "/category/cast" },
  { label: "精彩剧评", to: "/category/reviews" },
  { label: "最新动态", to: "/category/news" },
  { label: "关于本站", to: "/about" },
];

export default function SiteFooter() {
  return (
    <footer className="mt-20 bg-primary-900 text-background-50">
      <div className="mx-auto grid w-full max-w-content grid-cols-1 gap-10 px-4 py-14 md:grid-cols-4 md:px-6">
        <div className="md:col-span-2">
          <div className="flex items-center gap-2.5">
            <span className="flex h-9 w-9 items-center justify-center rounded-md bg-background-50 text-primary-700">
              <i className="ri-film-line text-lg"></i>
            </span>
            <span className="text-lg font-bold">我的朋友他的妻子</span>
          </div>
          <p className="mt-4 max-w-md text-sm leading-relaxed text-primary-100">
            本站是一个专注于影视剧《我的朋友他的妻子》的内容专题站，提供剧情介绍、演员资料、剧评分析与最新动态，
            帮助影迷更深入地了解剧集内容与幕后故事。
          </p>
          <p className="mt-4 text-xs text-primary-200">
            本站所有内容均为演示数据，仅用于内容展示与信息查阅。
          </p>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide">快速导航</h4>
          <ul className="mt-4 space-y-2.5">
            {quickLinks.map((link) => (
              <li key={link.to}>
                <Link
                  to={link.to}
                  className="text-sm text-primary-100 transition-colors hover:text-accent-300"
                >
                  {link.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h4 className="text-sm font-semibold tracking-wide">联系我们</h4>
          <ul className="mt-4 space-y-2.5 text-sm text-primary-100">
            <li className="flex items-center gap-2">
              <i className="ri-mail-line text-accent-300"></i>
              contact@example.com
            </li>
            <li className="flex items-center gap-2">
              <i className="ri-wechat-line text-accent-300"></i>
              微信公众号：影视专题站
            </li>
          </ul>
          <p className="mt-4 text-xs text-primary-200">
            以上联系方式均为演示用途。
          </p>
        </div>
      </div>

      <div className="border-t border-primary-800">
        <div className="mx-auto flex w-full max-w-content flex-col items-center justify-between gap-2 px-4 py-5 text-xs text-primary-200 sm:flex-row md:px-6">
          <span>© 2026 我的朋友他的妻子 · 影视内容专题站</span>
          <span>本站为演示站点 · 分享与收藏功能为前端演示</span>
        </div>
      </div>
    </footer>
  );
}